import { lazy } from 'react';
import type { RouteObject } from 'react-router';

import { MainLayout } from '@/layout';

const routes: RouteObject[] = [
  {
    path: 'api-key',
    Component: MainLayout,
    children: [
      {
        path: '',
        Component: lazy(() => import('@/page/apiKey/APIKeyPage')),
      },
    ],
  },
];

export default routes;
